import React from 'react';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';

import { getDefaultOptions } from './defaultOptions';
import { getEmbeddedOptions } from './embedOptions';

// Only get the richtext in html format, so it can be formatted by the caller itself
export const getRichtTextHtml = (richTextNode) => {
  const raw = richTextNode?.raw;
  const jsonParsed = JSON.parse(raw);

  const htmlOptions = {
    renderNode: getDefaultOptions(),
  };

  return documentToReactComponents(jsonParsed, htmlOptions);
};

// Wrapped richtext component which also embeds other components via 'references'
export const RichTextHtml = ({
  richTextNode,
  deqGroupTitle = null,
  deqGroupType = null,
  deqCompType,
}) => {
  // Grab the 2 separate nodes we need and parse them
  const raw = richTextNode?.raw;
  const references = richTextNode?.references;
  const jsonParsed = JSON.parse(raw);

  // Default custom html parsing options, like how to render <a> or <p> tags
  let options = getDefaultOptions(deqGroupTitle, deqGroupType, deqCompType);

  // Check if there is an embedded reference within the rich text
  if (references !== null) {
    const embeddedOptions = getEmbeddedOptions(references);
    options = { ...options, ...embeddedOptions };
  }

  const htmlOptions = {
    renderNode: options,
  };

  return <>{documentToReactComponents(jsonParsed, htmlOptions)}</>;
};

export const getUriEncodedRichText = (text) => {
  const jsonParsed = JSON.parse(text);

  const options = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, next) => `${next(node.content)}\n`,
    },
  };

  return encodeURIComponent(documentToHtmlString(jsonParsed, options));
};

export const getPlainTextEncodedRichText = (text) => {
  const jsonParsed = JSON.parse(text);
  return documentToPlainTextString(jsonParsed);
};
